import React from "react";
import Calendar from "@toast-ui/react-calendar";
import Modal from "../../Components/Modal/Modal";
import "./tui-calendar.css";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import axios from "axios";
import { PORT } from "../../config";
import { Divider } from "semantic-ui-react";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { notify } from "react-notify-toast";
import "./Availability.css";
import available_icon from "../../assets/img/availability-icon.png";
import not_available_icon from "../../assets/img/cross.png";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import { addDays } from "date-fns";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import { API } from "../../API";
import { parseTime, getClass, teacherResponse } from "../../Helper";
import { handleMultiDateBookings } from "../Bookings2/Helper";
import { updateToRoot } from "../../redux/homePage/homePage.actions"
import { connect } from "react-redux"
const _ = require('lodash');
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);

const WEEKLY_CUSTOM_THEME = {
  // week header 'dayname'
  "week.dayname.height": "41px",
  "week.dayname.borderTop": "1px solid #ddd",
  "week.dayname.borderBottom": "1px solid #ddd",
  "week.dayname.borderLeft": "1px solid #ddd",
  "week.dayname.paddingLeft": "5px",
  "week.dayname.backgroundColor": "inherit",
  "week.dayname.textAlign": "left",
  "week.today.color": "#b857d8",
  "week.pastDay.color": "#999",

  // week vertical panel 'vpanel'
  "week.vpanelSplitter.border": "1px solid #ddd",
  "week.vpanelSplitter.height": "3px",

  // week daygrid 'daygrid'
  "week.daygrid.borderRight": "1px solid #ddd",
  "week.daygrid.backgroundColor": "inherit",

  "week.daygridLeft.width": "77px",
  "week.daygridLeft.backgroundColor": "#a8def74d",
  "week.daygridLeft.paddingRight": "5px",
  "week.daygridLeft.borderRight": "1px solid #ddd",

  "week.today.backgroundColor": "#b857d81f",
  "week.weekend.backgroundColor": "inherit",

  // week timegrid 'timegrid'
  "week.timegridLeft.width": "77px",
  "week.timegridLeft.backgroundColor": "#03a9f44d",
  "week.timegridLeft.borderRight": "1px solid #ddd",
  "week.timegridLeft.fontSize": "12px",
  "week.timegridLeftTimezoneLabel.height": "51px",
  "week.timegridLeftAdditionalTimezone.backgroundColor": "#fdfdfd",

  "week.timegridOneHour.height": "48px",
  "week.timegridHalfHour.height": "24px",
  "week.timegridHalfHour.borderBottom": "1px dotted #f9f9f9",
  "week.timegridHorizontalLine.borderBottom": "1px solid #eee",

  "week.timegrid.paddingRight": "10px",
  "week.timegrid.borderRight": "1px solid #ddd",
  "week.timegridSchedule.borderRadius": "0",
  "week.timegridSchedule.paddingLeft": "0",

  "week.currentTime.color": "#135de6",
  "week.currentTime.fontSize": "12px",
  "week.currentTime.fontWeight": "bold",

  "week.pastTime.color": "#808080",
  "week.pastTime.fontWeight": "normal",

  "week.futureTime.color": "#333",
  "week.futureTime.fontWeight": "normal",

  "week.currentTimeLinePast.border": "1px solid rgba(19, 93, 230, 0.3)",
  "week.currentTimeLineBullet.backgroundColor": "#135de6",
  "week.currentTimeLineToday.border": "1px solid #135de6",
  "week.currentTimeLineFuture.border": "1px solid #135de6",

  // week creation guide style
  "week.creationGuide.color": "#135de6",
  "week.creationGuide.fontSize": "12px",
  "week.creationGuide.fontWeight": "bold",

  // week daygrid schedule style
  "week.dayGridSchedule.borderRadius": "0",
  "week.dayGridSchedule.height": "18px",
  "week.dayGridSchedule.marginTop": "2px",
  "week.dayGridSchedule.marginLeft": "10px",
  "week.dayGridSchedule.marginRight": "10px",
};

const initialExportBookingPopupState = {
  export_booking_popup: false,
  export_booking_start_date: moment(new Date()).format("YYYY-MM-DD"),
  export_booking_end_date: moment(new Date()).format("YYYY-MM-DD"),
}

const classList = getClass();

class toastcal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      isPopUp: false,
      isBookingPopUp: false,
      user: props.user,
      selected_date: "",
      schedules: [],
      from_date: "",
      to_date: "",
      gcal_events: "",
      isCalendarPopup: false,
      today: moment(new Date()).format("DD-MM-YYYY"),
      view: "month",
      visibleWeeksCount: 0,
      isWorkWeek: true,
      check_morning: "",
      check_afternoon: "",
      check_evening: "",
      check_all: "",
      check_none: "",
      toggleWeekend: "Show Weekend",
      campuses: [],
      institutions: [],
      startDate: moment(new Date()).startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD"),
      endDate: moment(new Date()).endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD"),
      ...initialExportBookingPopupState,
      grant_access_popup: false,
      loadedMonth: [],
      isFetchDataBooking: false,
      originalBookings: [],
      isRequestView: props?.isRequestView,
    };
  }

  calendarRef = React.createRef();

  getDate = (date) => {
    const currentDate = moment(date);
    const currentYear = currentDate.year();
    const currentMonth = moment(date).format("M"); // Add 1 because getMonth() returns 0-indexed months
    // Check if the previous month is loaded
    const previousMonth = moment(date).startOf('month').subtract(1, "days").format("M");

    const previousMonthYear = moment(date).startOf('month').subtract(1, "days").year();
    const previousMonthLoaded = this.state.loadedMonth.includes(previousMonthYear + '-' + previousMonth);
    // Check if the next month is loaded
    const nextMonth = moment(date).endOf('month').add(1, "days").format("M");
    const nextMonthYear = moment(date).endOf('month').add(1, "days").year();
    const nextMonthLoaded = this.state.loadedMonth.includes(nextMonthYear + '-' + nextMonth);
    // Check if the current month is loaded
    const currentMonthLoaded = this.state.loadedMonth.includes(currentYear + '-' + currentMonth);

    if (previousMonthLoaded && currentMonthLoaded && !nextMonthLoaded) {
      // Load data for the next month
      // Set the new end date to the last day of the next month
      const nextMonthStartDate = moment(date).endOf('month').add(1, 'days').startOf('month').format('YYYY-MM-DD');
      const nextMonthEndDate = moment(date).endOf('month').add(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.setState({isFetchDataBooking: true})
      this.setState({startDate: nextMonthStartDate});
      this.setState({endDate: nextMonthEndDate});
      const loadMonths = this.loadRangeOfMonths(nextMonthStartDate, nextMonthEndDate)
      this.setState({loadedMonth: [...this.state.loadedMonth, ...loadMonths]});
    } else if (nextMonthLoaded && currentMonthLoaded && !previousMonthLoaded) {
      // Load data for the previous month
      const previousMonthStartDate = moment(date).startOf('month').subtract(1, 'days').startOf('month').format('YYYY-MM-DD');
      const previousMonthEndDate = moment(date).startOf('month').subtract(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.setState({startDate: previousMonthStartDate});
      this.setState({endDate: previousMonthEndDate});
      this.setState({isFetchDataBooking: true})
      const loadMonths = this.loadRangeOfMonths(previousMonthStartDate, previousMonthEndDate)
      this.setState({loadedMonth: [...this.state.loadedMonth, ...loadMonths]});
    }
    else if (previousMonthLoaded && nextMonthLoaded && !currentMonthLoaded) {
      // Load data for the current month
      const currentStartDate = moment(date).startOf('month').format('YYYY-MM-DD');
      const currentMonthEndDate = moment(date).endOf('month').format('YYYY-MM-DD');
      this.setState({startDate: currentStartDate});
      this.setState({endDate: currentMonthEndDate});
      this.setState({isFetchDataBooking: true})
      const loadMonths = this.loadRangeOfMonths(currentStartDate, currentMonthEndDate)
      this.setState({loadedMonth: [...this.state.loadedMonth, ...loadMonths]});
    } else if (previousMonthLoaded && !currentMonthLoaded && !nextMonthLoaded) {
      // Load data for the current and next months
      const currentStartDate = moment(date).startOf('month').format('YYYY-MM-DD');
      const nextMonthEndDate = moment(date).endOf('month').add(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.setState({startDate: currentStartDate});
      this.setState({endDate: nextMonthEndDate});
      this.setState({isFetchDataBooking: true})
      const loadMonths = this.loadRangeOfMonths(currentStartDate, nextMonthEndDate)
      this.setState({loadedMonth: [...this.state.loadedMonth, ...loadMonths]});
    } else if(nextMonthLoaded && !previousMonthLoaded && !currentMonthLoaded) {
      // Load data for the current and previous months
      const previousMonthStartDate = moment(date).startOf('month').subtract(1, 'days').startOf('month').format('YYYY-MM-DD');
      const currentMonthEndDate = moment(date).endOf('month').format('YYYY-MM-DD');
      this.setState({startDate: previousMonthStartDate});
      this.setState({endDate: currentMonthEndDate});
      this.setState({isFetchDataBooking: true})
      const loadMonths = this.loadRangeOfMonths(previousMonthStartDate, currentMonthEndDate)
      this.setState({loadedMonth: [...this.state.loadedMonth, ...loadMonths]});
    } else if(!previousMonthLoaded && !currentMonthLoaded && !nextMonthLoaded) {
      // Load data for all three months
      const previousMonthStartDate = moment(date).startOf('month').subtract(1, 'days').startOf('month').format('YYYY-MM-DD');
      const nextMonthEndDate = moment(date).endOf('month').add(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.setState({startDate: previousMonthStartDate});
      this.setState({endDate: nextMonthEndDate});
      const loadMonths = this.loadRangeOfMonths(previousMonthStartDate, nextMonthEndDate)
      this.setState({isFetchDataBooking: true})
      this.setState({loadedMonth: [...this.state.loadedMonth, ...loadMonths]});
    }
  }

  isMonthLoaded = (year, month) => {
    return this.state.loadedMonth.includes(`${year}-${month}`);
  }

  loadRangeOfMonths = (startDate, endDate) => {
    // Convert the start and end dates to Moment objects
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const loadedMonths = [];
    // Loop through each month in the range and load the data if it hasn't been loaded before
    let currentMoment = startMoment.clone();
    while (currentMoment <= endMoment) {
      const year = currentMoment.year();
      const month = currentMoment.month() + 1; // add 1 to convert from 0-indexed to 1-indexed
      if (!this.isMonthLoaded(year, month)) {
        loadedMonths.push(`${year}-${month}`);
      }
      currentMoment = currentMoment.add(1, 'months');
    }

    return loadedMonths;
  }

  handleClickNextButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.next();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    });
    this.getDate(calendarInstance._renderDate._date);
  };

  handleClickPrevButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.prev();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    });
    this.getDate(calendarInstance._renderDate._date);
  };

  handlePickMonth = (date) => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.setDate(date);
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    });
    this.getDate(date);
  };

  handleRenderDate = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    });
  };

  handleClickTodayButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.today();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("DD-MM-YYYY"),
    });
    setTimeout(() => {
      document.querySelector('.tui-full-calendar-today')
        .scrollIntoView({ behavior: "smooth", block: "center" })
    }, 100)
  };

  async componentDidMount() {
    const { user } = this.state;

    setTimeout(() => {
      if (document.querySelector('.tui-full-calendar-today')) {
        document.querySelector('.tui-full-calendar-today')
          .scrollIntoView({ behavior: "smooth", block: "center" })
      }
    }, 100)


    let [instList, campusList, bookingList, schedules] = await Promise.all([
      (async () => {
        const result = await API.getAllInstWithCache()
        return result.data.map((inst) => {
          return {
            _id: inst._id,
            institution_name: inst.institution_name,
          };
        });
      })(),
      (async () => {
        const result = await API.getAllCampusWithCache()
        return result.data.map((campus) => {
          return {
            _id: campus._id,
            campus_shortname: campus.campus_shortname,
            address_line1: campus.address_line1,
            address_line2: campus.address_line2,
            institution_id: campus.institution_id,
          };
        });
      })(),
      (async () => {
        const loadedMonths = this.loadRangeOfMonths(this.state.startDate, this.state.endDate);
        this.setState({loadedMonth: [...this.state.loadedMonth, ...loadedMonths]})
        const result = await API.getAllBookingsByTeacherIDPagination(user._id, ["rejected", "cancelled"], this.state.startDate, this.state.endDate)

        return handleMultiDateBookings(
          result.data,
          user._id
        )
          .filter((booking) => {
            return (
              !booking.cancelled_by_inst &&
              booking.teacher_response !== teacherResponse.not_responded &&
              booking.teacher_response !== teacherResponse.rejected
            );
          });
      })(),
      (async () => {
        const result = await API.getInterviewJobList(user._id)
        const jobListings = result.data.listings
        let schedules = []
        if (jobListings.length > 0) {
          schedules = jobListings.filter((listing) => {
            const scheduleInfos = listing.invited_interview?.find((int) => int.teacher_id === this.props.user._id)
              ?.interview_schedule_infos
            if (scheduleInfos) {
              for (let i = 0; i < scheduleInfos.length; i++) {
                if (scheduleInfos[i].status === 'selected' && scheduleInfos[i].preferred_time) {
                  listing.scheduleInfos = scheduleInfos[i]
                  return true
                }
              }
            }
            return false
          })
        }
        return schedules
      })()
    ])

    if (user.rules?.[0]) {
      const rules = user.rules[0];
      // console.log("rules: ", rules)

      this.state.originalBookings.forEach(booking => {
        const date = booking?.end_booking_date?.split("-").reverse().join("-")
        const rule = rules[date]
        const bookingTime = this.getTeacherAvailabilityFromBooking(booking)
        // console.log("check: ", date, rule, bookingTime)
        if(rule) {
          let newTime = rule.time
          const index = rule.time.indexOf(bookingTime)
          // console.log("timee: ", newTime, index)
          if(index >= 0) {
            newTime = [
              ...rule.time.slice(0, index),
              ...rule.time.slice(index + 1)
            ]
          }
          if(newTime?.length) {
            rules[date] = {
              ...rules[date],
              time: newTime
            }
          }
          else {
            delete rules[date]
          }
        }
      })

      const result = Object.keys(rules).map(function (key) {
        if (rules[key]) {
          const items = key.split("-");
          var formatDate = `${items[2]}-${items[1]}-${items[0]}`;
          return {
            title:
              rules[key].time.length === 4 || (rules[key].time.length === 3 && !rules[key]?.time?.includes('All'))
                ? "All Day"
                : rules[key].time?.filter(item => item !== 'All').toString(),
            category: "time",
            dueDateClass: "",
            borderColor: "#fff",
            start: moment.utc(rules[key].date, "DD-MM-YYYY").toDate(),
            end: moment.utc(rules[key].date, "DD-MM-YYYY").toDate(),
          };
        }
      });
      this.setState({ schedules: result })
    }
    this.setState({
      institutions: instList,
      campuses: campusList
    })

    this.setBookingEvents(bookingList)
    this.setInterviewSchedule(schedules)

    const getET = async () => {
      let etStatus = await API.getetstat(user._id);
      this.setState({et : etStatus.data.data})
     }
     getET()
     
  }

  getTeacherAvailabilityFromBooking = (booking) => {
    const { end_time } = booking
    if(end_time <= "15:00:00") {
      return "Morning"
    }
    else {
      return "Evening"
    }
  }

  fetchAllBookings = async () => {
    const {user, startDate, endDate} = this.state
    try {
      if(this.state.isFetchDataBooking) {
        const response = await API.getAllBookingsByTeacherIDPagination(user._id, ["rejected", "cancelled"], startDate, endDate)
        const result = handleMultiDateBookings(
          response.data,
          user._id
        )
          .filter((booking) => {
            return (
              !booking.cancelled_by_inst &&
              booking.teacher_response !== teacherResponse.not_responded &&
              booking.teacher_response !== teacherResponse.rejected
            );
          });
          this.setState({isFetchDataBooking: false})
          this.setBookingEvents(result)
      }
    } catch (error) {
      console.log(error)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.startDate !== this.state.startDate) {
      this.fetchAllBookings()
    }
  }

  setInterviewSchedule = (interviewSchedules) => {
    let events = [];
    interviewSchedules.forEach((interview) => {
      const inst = this.state.institutions.find((ins) => ins._id === interview.inst_id);
      const interview_sche = {
        id: interview._id,
        calendarId: 2,
        title: interview.title + " Interview",
        category: "allday",
        dueDateClass: "",
        bgColor: "#0c05cc",
        isReadOnly: true,
        start: new Date(interview.scheduleInfos.preferred_time),
        end: new Date(interview.scheduleInfos.preferred_time),
        location: interview.scheduleInfos.preferred_location === "online"
          ? interview.scheduleInfos.meeting_link
          : interview.scheduleInfos.campus + ", " + (inst ? inst.institution_name : ""),
        state: interview.scheduleInfos.preferred_location === "online" ? "Online" : "On Campus",
        body: JSON.stringify({
          start_time: interview.scheduleInfos.preferred_time,
        }),
      };
      events.push(interview_sche)
    })

    this.setState({ gcal_events: events }, () => {
      let prevState = this.state.schedules;
      if (prevState) {
        this.setState({ schedules: [...prevState, ...events] });
      } else {
        this.setState({ schedules: events });
      }
    });
    // console.log(this.state.schedules);
  };

  getClassName = (key) => {
    const cls = classList.find((cl) => cl.key === key) || {};
    return cls.whole_name;
  };

  getAmPmEve = (timeString) => {
    const timeArray = timeString.split(":");
    let hour = parseInt(timeArray[0]);
    return hour < 12 ? "AM" : hour < 15 ? "PM" : "EVE";
  };

  setBookingEvents = (bookings) => {
    let events = [];
    bookings.forEach((booking) => {
      const title =
        // this.getClassName(booking.level) +
        booking.level +
        " " +
        this.getAmPmEve(booking.start_time);

      let inst;
      let campus = this.state.campuses.find(
        (cam) => cam._id === booking.campus_id
      );

      if (!campus || !campus._id && booking?.campus) {
        campus = booking.campus
      }

      if (campus) {
        inst = this.state.institutions.find(
          (ins) => ins._id === campus.institution_id
        );
      }

      if (booking.multiple_date) {
        const dates =
          booking.dates.filter(function (dates) {
            return (
              dates.date >= booking.booking_date &&
              dates.date <= booking.end_booking_date
            );
          }) || [];
        dates.forEach((date) => {
          // use original_dates instead of dates to find the correct index of date
          const indexItem = booking.original_dates.find(item => item.date === date.date)
          const index = booking.original_dates.indexOf(indexItem)
          if (!date.cancelled_by_inst && !date.teacher_cancel_reason) {
            if (date.teacher_id === this.props.user._id) {
              const booking_sche = {
                id: `${booking._id}_${index}`,
                calendarId: 1,
                title: title,
                category: "allday",
                dueDateClass: "",
                isReadOnly: true,
                start: new Date(date.date),
                end: new Date(date.date),
                location: inst || campus
                  ? `${campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')}, ${inst?.institution_name}`
                  : "",
                state: booking.online ? "Online" : "On Campus",
                body: JSON.stringify({
                  arrival_time: date.arrival_time
                    ? date.arrival_time
                    : booking.arrival_time,
                  start_time: date.start_time
                    ? date.start_time
                    : booking.start_time,
                  end_time: date.end_time ? date.end_time : booking.end_time,
                  isAdmin: this.props.isAdmin,
                }),
              };

              var duplication = false;
              for (let e of events) {
                if (booking._id === e.id) {
                  duplication = true;
                  break;
                }
              }
              if (!duplication) {
                events.push(booking_sche);
              }
            }
          }
        });
      } else {
        events.push({
          id: booking._id,
          calendarId: 1,
          title: title,
          category: "allday", //'milestone', 'task', allday', 'time'
          dueDateClass: "START",
          borderColor: "#fff",
          isReadOnly: true,
          start: new Date(booking.booking_date),
          end: new Date(booking.booking_date),
          location: inst
            ? `${campus.campus_shortname}, ${inst.institution_name}`
            : "",
          state: booking.online ? "Online" : "On Campus",
          body: JSON.stringify({
            arrival_time: booking.arrival_time,
            start_time: booking.start_time,
            end_time: booking.end_time,
            isAdmin: this.props.isAdmin,
          }),
        });
      }
    });

    this.setState({ gcal_events: events, originalBookings: bookings }, () => {
      let prevState = this.state.schedules;
      if (prevState) {
        const itemWithID = [...prevState, ...events].filter(item => item.id)
        const itemWithoutID = [...prevState, ...events].filter(item => !item.id)
        this.setState({ schedules: [...itemWithoutID,  ..._.uniqBy([...itemWithID],'id')] });
      } else {
        this.setState({ schedules: events });
      }
    });
    // console.log(this.state.schedules);
  };

  // Stores updated availability rules to database
  saveDate = async (e) => {
    e.preventDefault()
    const { selected_date, user, from_date, to_date } = this.state;

    if (from_date > to_date) {
      notify.show("Booking end date must be after start date.");
      return;
    }

    let date = moment(selected_date).format("MM-DD-YYYY");
    if (date) {
      const userData = user;

      const checkboxes = document.getElementsByName("balloon-radio-group2");
      const selectedCboxes = Array.prototype.slice
        .call(checkboxes)
        .filter((ch) => ch.checked === true);
      const time_slots = selectedCboxes.map((item) => item.id); //morning,after,even
      const range = moment.range(from_date, to_date);

      const selected_afternoons = Array.from(range.by("days")).map(
        (m) => m.format("dddd") + " - " + m.format("DD-MM-YYYY")
      );

      let updated_rules = [{}];
      let set_time = [];
      if (!userData.rules[0]) userData.rules = [{}]; //initiate
      if (userData.rules[0]) updated_rules[0] = userData.rules[0]; //old rules
      selected_afternoons.forEach((sd) =>
        time_slots.forEach((ts_arr, index) => {
          const date = sd.split(" - ")[1];
          let time = ts_arr[0].toUpperCase() + ts_arr.slice(1);
          time = time === "None" ? "Not Available" : time;
          if (updated_rules[0][date]) {
            if (updated_rules[0][date].time) {
              set_time = [...set_time, time];
            } else {
              set_time = [time];
            }
          } else {
            set_time = [time];
          }
          //entries data
          updated_rules[0][date] = {
            time: [...new Set(set_time)],
            day: moment(date, "DD-MM-YYYY").format("dddd"),
            date: date,
          };
        })
      );

      await this.props.updateAvailability(userData);
      API.getUserSafeData()
        .then((res) => {
          const user = res.data.user;
          this.props.updateToRoot(user);
          // this.setState({ user });
        })
        .catch((err) => {
          console.log(err);
        });

      let rules = userData.rules[0];
      var result = Object.keys(rules).map(function (key) {
        if (rules[key]) {
          return {
            title:
              rules[key].time.length === 4 || rules[key].time.length === 3
                ? "All Day"
                : rules[key].time.toString(),
            category: "time",
            dueDateClass: "",
            start: moment(rules[key].date, "DD-MM-YYYY").toDate(),
            end: moment(rules[key].date, "DD-MM-YYYY").toDate(),
          };
        }
      });

      // Email notification
      API.sendTeacherProfileProgressEmail({
        _id: this.props.user._id,
        to: this.props.user.email,
        first_name: this.props.user.first_name,
        etype: "AVAI_CONF",
      }).then((result) => {
          console.log("result:", result);
        })
        .catch((err) => {
          console.log("err:", err);
        });

      this.togglePopup(false);
      this.setState({ schedules: [...result, ...this.state.gcal_events] }, () =>
        setTimeout(() => { window.location.reload(false) }, 2500)
      );
    }
  };

  updateTeacherAvailability = async (e) => {
    e.preventDefault()
    const { selected_date, user, from_date, to_date } = this.state;

    if (from_date > to_date) {
      notify.show("Booking end date must be after start date.");
      return;
    }

    let date = moment(selected_date).format("MM-DD-YYYY");
    if (date) {
      const userData = user;

      const checkboxes = document.getElementsByName("balloon-radio-group2");
      const selectedCboxes = Array.prototype.slice
        .call(checkboxes)
        .filter((ch) => ch.checked === true);
      let times = selectedCboxes.map((item) => `${item.id[0].toUpperCase()}${item.id.slice(1)}`); //morning,after,even
      times = times.map(time => time === "None" ? "Not Available" : time)
      const range = moment.range(from_date, to_date);

      const selectedDates = Array.from(range.by("days")).map(
        (m) => m.format("YYYY-MM-DD")
      );

      try {
        const response = await API.sendAvailability(selectedDates, times)
        const newUser = response?.data?.user
        let result;
        if (newUser.rules?.[0]) {
          const rules = newUser.rules[0];
          // console.log("rules: ", rules)
          const bookingList = this.state.originalBookings
          bookingList.forEach(booking => {
            const date = booking?.end_booking_date?.split("-").reverse().join("-")
            const rule = rules[date]
            const bookingTime = this.getTeacherAvailabilityFromBooking(booking)
            // console.log("check: ", booking?.end_booking_date, date, rule, bookingTime)
            if(rule) {
              let newTime = rule.time
              const index = rule.time.indexOf(bookingTime)
              // console.log("timee: ", newTime, index)
              if(index >= 0) {
                newTime = [
                  ...rule.time.slice(0, index),
                  ...rule.time.slice(index + 1)
                ]
              }
              if(newTime?.length) {
                rules[date] = {
                  ...rules[date],
                  time: newTime
                }
              }
              else {
                delete rules[date]
              }
            }
          })
    
          result = Object.keys(rules).map(function (key) {
            if (rules[key]) {
              const items = key.split("-");
              var formatDate = `${items[2]}-${items[1]}-${items[0]}`;
              return {
                title:
                  rules[key].time.length === 4 || (rules[key].time.length === 3 && !rules[key]?.time?.includes('All'))
                    ? "All Day"
                    : rules[key].time?.filter(item => item !== 'All').toString(),
                category: "time",
                dueDateClass: "",
                borderColor: "#fff",
                start: moment(rules[key].date, "DD-MM-YYYY").toDate(),
                end: moment(rules[key].date, "DD-MM-YYYY").toDate(),
              };
            }
          });
        }

        // Email notification
        API.sendTeacherProfileProgressEmail({
          _id: this.props.user._id,
          to: this.props.user.email,
          first_name: this.props.user.first_name,
          etype: "AVAI_CONF",
        }).then((result) => {
            console.log("result:", result);
          })
          .catch((err) => {
            console.log("err:", err);
          });

        const selectedMonthStartDate = moment(this.state.today, 'DD-MM-YYYY').startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD");
        const selectedMonthEndDate = moment(this.state.today, 'DD-MM-YYYY').endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD");
        this.togglePopup(false);
        this.setState({ schedules: [...result, ...this.state.gcal_events], isFetchDataBooking: true, startDate: selectedMonthStartDate
          ,endDate: selectedMonthEndDate, loadedMonth: [] }, () => {
          this.props.updateToRoot(newUser);
          const loadedMonths = this.loadRangeOfMonths(selectedMonthStartDate, selectedMonthEndDate);
          this.setState({loadedMonth: [...this.state.loadedMonth, ...loadedMonths]});
          this.fetchAllBookings()
          notify.show("Updated successfully", "success")
          // setTimeout(() => { window.location.reload(false) }, 2500)
        });

      } catch (error) {
        notify.show(error?.response?.data?.error || error.message, "error", 3000)
      }
    }
  }

  updateTeacherAvailabilityByAdmin = async (e) => {
    e.preventDefault()
    const { selected_date, user, from_date, to_date } = this.state;
    if (from_date > to_date) {
      notify.show("Booking end date must be after start date.");
      return;
    }

    let date = moment(selected_date).format("MM-DD-YYYY");
    if (date) {
      const checkboxes = document.getElementsByName("balloon-radio-group2");
      const selectedCboxes = Array.prototype.slice
        .call(checkboxes)
        .filter((ch) => ch.checked === true);
      let times = selectedCboxes.map((item) => `${item.id[0].toUpperCase()}${item.id.slice(1)}`); //morning,after,even
      times = times.map(time => time === "None" ? "Not Available" : time)
      const range = moment.range(from_date, to_date);

      const selectedDates = Array.from(range.by("days")).map(
        (m) => m.format("YYYY-MM-DD")
      );

      try {
        const response = await API.sendAvailabilityByAdmin(selectedDates, times, user._id)
        const newUser = response?.data?.user
        
        let rules = newUser.rules[0];
        const result = Object.keys(rules).map(function (key) {
          if (rules[key]) {
            return {
              title:
                rules[key].time.length === 4 || rules[key].time.length === 3
                  ? "All Day"
                  : rules[key].time.toString(),
              category: "time",
              dueDateClass: "",
              start: moment(rules[key].date, "DD-MM-YYYY").toDate(),
              end: moment(rules[key].date, "DD-MM-YYYY").toDate(),
            };
          }
        });

        const selectedMonthStartDate = moment(this.state.today, 'DD-MM-YYYY').startOf("month").add(-1, 'days').startOf("month").format("YYYY-MM-DD");
        const selectedMonthEndDate = moment(this.state.today, 'DD-MM-YYYY').endOf("month").add(1, 'days').endOf("month").format("YYYY-MM-DD");
        this.togglePopup(false);
        this.setState({ schedules: [...result, ...this.state.gcal_events], isFetchDataBooking: true, startDate: selectedMonthStartDate
        ,endDate: selectedMonthEndDate, loadedMonth: [] }, () => {
          window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(newUser));
          const loadedMonths = this.loadRangeOfMonths(selectedMonthStartDate, selectedMonthEndDate);
          this.setState({loadedMonth: [...this.state.loadedMonth, ...loadedMonths]});
          this.fetchAllBookings()
          notify.show("Updated successfully", "success")
        });

      } catch (error) {
        notify.show(error?.response?.data?.error || error.message, "error", 3000)
      }
    }
  }

  setData = (data) => {
    this.setState(data);
  };

  setDateOnDateClick = (value) => {
    this.setState({ selected_date: value });
    this.setState({ from_date: value });
    this.setState({ to_date: value });
  };

  getGridTitleTemplate = (type) => {
    var title = "";
    // eslint-disable-next-line default-case
    switch (type) {
      case "milestone":
        title = '<span class="tui-full-calendar-left-content">MILESTONE</span>';
        break;
      case "task":
        title = '<span class="tui-full-calendar-left-content">TASK</span>';
        break;
      case "allday":
        title = '<span class="tui-full-calendar-left-content">ALL DAY</span>';
        break;
    }
    return title;
  };

  setDate = (date) => {
    this.setState({ selected_date: date });
    setTimeout(() => {
      console.log(`Button Name (⏳ setTimeout) = ${this.state.selected_date}`);
    }, 100);
    return date;
  };

  onHideWeekend = () => {
    this.setState({ isWorkWeek: !this.state.isWorkWeek });
    let value =
      this.state.toggleWeekend === "Hide Weekend"
        ? "Show weekend"
        : "Hide Weekend";
    this.setState({ toggleWeekend: value });
  };

  getGridCategoryTemplate = (category, schedule) => {
    var tpl;
    // eslint-disable-next-line default-case
    switch (category) {
      case "allday":
        tpl =
          '<span class="calendar-font-icon ic-milestone-b"></span> <span style="background-color: ' +
          schedule.bgColor +
          '">' +
          schedule.title +
          "</span>";
        break;
      case "task":
        tpl = "#" + schedule.title;
        break;
    }
    return tpl;
  };

  // Handles dropwodn button change
  onViewChange = (event) => {
    // view = event.target.value;
    if (event.target.value === "2 weeks") {
      this.setState({ visibleWeeksCount: 2 });
      this.setState({ view: "month" });
    } else if (event.target.value === "month") {
      this.setState({ visibleWeeksCount: 0 });
      this.setState({ view: event.target.value });
    } else {
      this.setState({ view: event.target.value });
    }
  };

  changeSelect = (e) => {
    this.setState({ [`check_${e.target.id}`]: e.target.checked }, () => {
      if (
        this.state.check_morning &&
        this.state.check_afternoon &&
        this.state.check_evening
      ) {
        this.setState({ check_all: true });
      }
    });
    if (e.target.checked) {
      if (e.target.id === "all") {
        this.setState({
          check_morning: true,
          check_afternoon: true,
          check_evening: true,
          check_none: false,
        });
      } else if (e.target.id === "none") {
        this.setState({
          check_morning: false,
          check_afternoon: false,
          check_evening: false,
          check_all: false,
        });
      } else {
        this.setState({
          check_none: false,
        });
      }
    } else {
      this.setState({
        check_all: false,
      });
    }
  };

  handleClose = () => {
    this.setState({ isPopUp: false });
  };
  togglePopup = (value) => {
    this.setState({ isPopUp: value });
  };
  handleBookingClose = () => {
    this.setState({ isBookingPopUp: false });
  };
  toggleBookingPopup = (value) => {
    this.setState({ isBookingPopUp: value });
  };
  toggleCalendar = (value) => {
    this.setState({ isCalendarPopup: value });
  };
  handlePopUpClose = (value) => {
    this.setState({ isCalendarPopup: value });
  };

  handleExportBooking = () => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = `Bookings from ${
      moment(this.state.export_booking_start_date).format("DD-MM-YYYY")} to ${
      moment(this.state.export_booking_end_date).format("DD-MM-YYYY")}`
    API.exportTeacherBookingsByAdmin(
      [this.props.user._id],
      this.state.export_booking_start_date,
      this.state.export_booking_end_date,
    ).then((res) => {
      link.href = URL.createObjectURL(
        new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" })
      );
      link.click();
      this.setState({ export_booking_popup: false })
    }).catch((err) => {
      console.log(err);
    })
  }
  

  render() {
    const {
      isPopUp,
      isBookingPopUp,
      isCalendarPopup,
      user,
      lastclickSchedule,
      selected_date,
      schedules,
      gcal_events,
      to_date,
      from_date,
      today,
      startDate,
      endDate,
      isRequestView,
      et,
      ettmp,
      etModal
    } = this.state;
    const etChange = (e) => {
      const isChecked = e.target.checked;
      this.setState({ettmp : isChecked})
      this.setState({etModal : true})
    }
    const etupdate = async (et) => {
      const upET = await API.etUpdate({
        data : {id : user._id,
                et : et
                }
      })
      console.log(et)
    }
    return (
      <div>
        <Modal
          show={isPopUp}
          className="book-teacher-modal"
          onClose={this.handleClose}
          header={
            <>
              Set availability for <br />
              {selected_date ? moment(selected_date).format("DD-MM-YYYY") : ""}
            </>
          }
        >
          <Divider horizontal>Or</Divider>
          <label className="w-100">
            <p className="text-center mt-2">Choose a date range</p>
          </label>
          <div className="row mt-3 availability-rule-dates-section justify-content-center">
            {/* <div className='col-6 pr-2 pl-5'> */}
            <div className="col availability-date-picker mx-5">
              <div className="form-group">
                <div className="input-icon">
                  <FormDatePicker
                    label="From"
                    id="from_date"
                    placeholderText={new Date()
                      .toLocaleDateString()
                      .split(/\//)
                      .join("-")}
                    showYearDropdown
                    showMonthDropdown
                    popperClassName="some-custom-class"
                    isClearable
                    showPopperArrow={false}
                    dropdownMode="select"
                    dateFormatCalendar="MMMM"
                    dateFormat="dd-MM-yyyy"
                    minDate={addDays(new Date(), 0)}
                    yearDropdownItemNumber={5}
                    scrollableYearDropdown
                    onChange={(date) => this.setState({ from_date: date })}
                    selected={from_date ? from_date : selected_date}
                  />
                </div>
              </div>
            </div>
            <div className="col availability-date-picker">
              <div className="form-group">
                <div className="input-icon">
                  <FormDatePicker
                    label="To"
                    id="to_date"
                    placeholderText={new Date()
                      .toLocaleDateString()
                      .split(/\//)
                      .join("-")}
                    showYearDropdown
                    showMonthDropdown
                    popperClassName="some-custom-class"
                    isClearable
                    showPopperArrow={true}
                    dropdownMode="select"
                    dateFormatCalendar="MMMM"
                    dateFormat="dd-MM-yyyy"
                    yearDropdownItemNumber={10}
                    minDate={addDays(new Date(), 0)}
                    scrollableYearDropdown
                    onChange={(date) => {
                      this.setState({ to_date: date });
                    }}
                    selected={to_date ? to_date : selected_date}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3 justify-content-around align-items-center">
            <div className="availability-radio-button px-1">
              <CheckableButton
                id="morning"
                name="balloon-radio-group2"
                checkbox
                onChange={this.changeSelect}
                checked={this.state.check_morning}
              >
                Morning
              </CheckableButton>
            </div>
            <div className="availability-radio-button px-1">
              <CheckableButton
                id="afternoon"
                name="balloon-radio-group2"
                checkbox
                checked={this.state.check_afternoon}
                onChange={this.changeSelect}
              >
                Afternoon
              </CheckableButton>
            </div>
            <div className="availability-radio-button px-1">
              <CheckableButton
                id="evening"
                name="balloon-radio-group2"
                checkbox
                checked={this.state.check_evening}
                onChange={this.changeSelect}
              >
                Evening
              </CheckableButton>
            </div>
          </div>

          <div className="row mt-3 justify-content-center align-items-center">
            <div className="availability-radio-button px-1">
              <CheckableButton
                id="all"
                name="balloon-radio-group2"
                checkbox
                onChange={this.changeSelect}
                checked={this.state.check_all}
              >
                All Day
              </CheckableButton>
            </div>
            <div className="availability-radio-button px-1">
              <CheckableButton
                id="none"
                checkbox
                name="balloon-radio-group2"
                onChange={this.changeSelect}
                checked={this.state.check_none}
              >
                Not Available
              </CheckableButton>
            </div>
          </div>

          <div className="row mt-5 justify-content-center">
            <div className="col-md-6 ">
              <ConfirmButton
                type="button"
                onClick={this.props.isAdmin ? this.updateTeacherAvailabilityByAdmin : this.updateTeacherAvailability}
                disabled={
                  !(
                    this.state.check_morning ||
                    this.state.check_afternoon ||
                    this.state.check_evening ||
                    this.state.check_all ||
                    this.state.check_none
                  )
                }
              >
                {this.props.isAdmin ? "Update" : "Submit"}
              </ConfirmButton>
            </div>
          </div>
        </Modal>

        {this.state.export_booking_popup && (
          <Modal
            show={true}
            header="Export Bookings"
            className="export-booking-modal"
            onClose={() => this.setState({ export_booking_popup: false })}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-8">
                <FormDatePicker
                  label="Start Date"
                  onChange={(date) => {
                    this.setState({ export_booking_start_date: moment(date).format("YYYY-MM-DD") })
                    moment(date).format("YYYY-MM-DD") > this.state.export_booking_end_date
                      ? this.setState({ export_booking_end_date: moment(date).format("YYYY-MM-DD") })
                      : console.log("end export booking date", this.state.export_booking_end_date);
                  }}
                  value={moment(this.state.export_booking_start_date).format("DD-MM-YYYY")}
                  // maxDate={new Date()}
                  dateFormat="YYYY-MM-DD"
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-8">
                <FormDatePicker
                  label="End Date"
                  onChange={(date) =>
                    this.setState({ export_booking_end_date: moment(date).format("YYYY-MM-DD") })}
                  value={moment(this.state.export_booking_end_date).format("DD-MM-YYYY")}
                  dateFormat="YYYY-MM-DD"
                  minDate={new Date(this.state.export_booking_start_date)}
                  // maxDate={new Date()}
                  maxWidth
                  required
                />
              </div>
              <div className="mt-5 col-md-8 d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={this.handleExportBooking}
                >
                  Export
                </button>
              </div>
            </div>
          </Modal>
        )}

        <div id="menu" className="calendar-menu ml-3">
          <span className="dropdown">
            <select
              className="btn btn-default btn-sm dropdown-toggle dropwn"
              onChange={this.onViewChange}
            >
              <option value="month">Monthly</option>
              <option value="2 weeks">2 weeks</option>
            </select>
          </span>
          <span id="menu-navi">
            <button
              type="button"
              className="btn btn-default btn-sm hideWeekend"
              data-action="move-today"
              onClick={this.onHideWeekend}
            >
              {this.state.toggleWeekend}
            </button>
            <button
              type="button"
              className="btn btn-default btn-sm move-today"
              data-action="move-today"
              onClick={this.handleClickTodayButton}
            >
              Today
            </button>
          </span>
          <span className='mt-3 ml-2 calendar-month-picker'>
            <FormDatePicker
              onChange={(date) => this.handlePickMonth(date)}
              selectsEnd
              dateFormat="YYYY / MMMM"
              showMonthYearPicker
              value={moment(today, "DD-MM-YYYY").format("YYYY / MMMM")}
              maxWidth
            />
          </span>
          <button
            className="btn secondary-button-no-margin-hover btn-c ml-3"
            onClick={() => this.setState({ export_booking_popup: true })}
          >
            Export Bookings
          </button>
          <CheckableButton
              toggle
              id="et"
              onChange={(e)=>{etChange(e)}}
              checked={et}
            >
              {
                this.props.user?.is_childhood_teacher
                  ? "Receive morning call for emergency shifts"
                  : "Receive morning call for emergency teaching"
              }
            </CheckableButton>
            <Modal
              show={etModal}
              header="Morning Emergency Teaching"
              className="export-booking-modal"
              onClose={() => this.setState({ etModal: false })}
            >
              
          <button
            className="btn secondary-button-no-margin-hover btn-c ml-3"
            onClick={() => {
              this.setState({ etModal: false })
              this.setState({ et: ettmp })
              etupdate(ettmp)
            }}
          >
            {
              ettmp
              ? 'I am Available for ET'
              : 'I am NOT Available for ET'
            }
          </button>
          <p style={{ marginTop: '1em' }}>
              {
                ettmp  
                ? 'Please ensure your phone is switched on from 6.00am. Thank you.'
                : 'You will be considered for morning classes with advanced warning and will not receive a wake-up call.'
              }
          </p>
            </Modal>
        </div>
        <div className="calendar-info-icon d-flex items-center">
          <div className="small-screen-disappear" hidden={this.props.isAdmin}>
            <HoverIcon
              icon="info circle"
              color="grey"
              text="Click on any future date to set availability. To view your booking details, click on the Job List tab."
              size="huge"
              place="left"
            />
          </div>
          <div className="small-screen-appear" hidden={this.props.isAdmin}>
            <HoverIcon
              icon="info circle"
              color="grey"
              text="Click on any future date to set availability. To view your booking details, navigate via dropdown to Job List."
              size="huge"
              place="left"
            />
          </div>
          {
            isRequestView &&  (
              <button
                className="btn secondary-button-no-margin-hover btn-c ml-3"
                onClick={() => this.setState({ grant_access_popup: true })}
              >
                Grant access
              </button>
            )
          }
          {
            this.state.grant_access_popup && (
              <Modal
                show={true}
                header="Grant access"
                className="export-booking-modal"
                onClose={() => this.setState({ grant_access_popup: false })}
              >
                <div className="row d-flex justify-content-center">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <a className="mb-3" href={`/GrantAccess?accept=true&day=7&request_view_id=${isRequestView}`}>
                    <button className="btn secondary-button-no-margin-hover" style={{ width: '180px' }}>Grant Access For 7 Days</button>
                    </a>
                    <a href={`/GrantAccess?accept=true&day=30&request_view_id=${isRequestView}`}>
                    <button className="btn secondary-button-no-margin-hover" style={{ width: '180px' }}>Grant Access For 30 Days</button>
                    </a>
                  </div>
                </div>
              </Modal>
            )
          }
          <div className='mr-3 ml-1'>
            <button
              type="button"
              className="btn btn-default btn-sm move-day mr-3"
              data-action="move-prev"
              onClick={this.handleClickPrevButton}
            >
              <i
                className="fa fa-arrow-left text-white"
                data-action="move-prev"
              />
            </button>
            <button
              type="button"
              className="btn btn-default btn-sm move-day"
              data-action="move-next"
              onClick={this.handleClickNextButton}
            >
              <i
                className="fa fa-arrow-right text-white"
                data-action="move-next"
              />
            </button>
          </div>
        </div>

        <Modal>{/* Create a hover of My Calender Pop up */}</Modal>

        <div id="teacher-calendar-container" className='col'>
          <Calendar
            height="740px"
            taskView={true}
            today={true}
            view={this.state.view}
            alldayView={false}
            useCreationPopup={false}
            useDetailPopup={true}
            theme={WEEKLY_CUSTOM_THEME}
            month={{
              workweek: this.state.isWorkWeek,
              startDayOfWeek: 0,
              visibleWeeksCount: this.state.visibleWeeksCount,
              isAlways6Week: false
            }}
            week={{
              workweek: this.state.isWorkWeek,
            }}
            ref={this.calendarRef}
            calendars={[
              {
                id: "1",
                bgColor: "#3bb4d8",
              },
            ]}
            onBeforeCreateSchedule={(e) => {
              if (true) {
                let missing_fields = []
                if (this.props.user) {
                  if (this.props.user.img_url === '') {
                    missing_fields.push('Profile Photo')
                  }

                  if (!this.props.user.first_name || !this.props.user.last_name || !this.props.user.contact_number ||
                    !this.props.user.address_line1) {
                    missing_fields.push('Personal Details')
                  }

                  if (!this.props.user.id_document_type || !this.props.user.identification_document_number
                    || !this.props.user.issuing_place || !this.props.user.id_document_expiry ||
                    !this.props.user.identification_filename) {
                    missing_fields.push('Identification')
                  }

                  if (this.props.user.referees.length === 0) {
                    missing_fields.push('Professional Referee')
                  }

                  if (this.props.user.is_elt === true) {
                    if (this.props.user.qualifications && this.props.user.qualifications.length === 0) {
                      missing_fields.push('ELT Qualifications')
                    } else if (this.props.user.professional_experience.length === 0) {
                      missing_fields.push('ELT Professional Experience')
                    }
                  }

                  if (this.props.user.is_vet === true) {
                    if ((this.props.user.vet_training_quals && this.props.user.vet_training_quals.length === 0)
                      && (this.props.user.vet_industry_quals && this.props.user.vet_industry_quals.length === 0)) {
                      missing_fields.push('VET Qualifications')
                    } else if ((this.props.user.vet_training_exp && this.props.user.vet_training_exp.length === 0) &&
                      (this.props.user.vet_industry_exp && this.props.user.vet_industry_exp.length === 0)) {
                      missing_fields.push('VET Experience')
                    }
                  }

                  let notification_text = 'Please complete the following items before adding your availability: '
                    + missing_fields.join(', ')
                  if (missing_fields.length > 0) {
                    notify.show(notification_text);
                    return false;
                  }
                }

                if (moment().subtract(1, "days").isBefore(e.start._date)) {
                  this.togglePopup(true);
                  this.setState(
                    {
                      selected_date: e.start._date,
                      check_morning: this.props.isSelect(
                        "Morning",
                        e.start._date
                      ),
                      check_afternoon: this.props.isSelect(
                        "Afternoon",
                        e.start._date
                      ),
                      check_evening: this.props.isSelect(
                        "Evening",
                        e.start._date
                      ),
                      check_all: this.props.isSelect("All", e.start._date),
                      check_none: this.props.isSelect(
                        "Not Available",
                        e.start._date
                      ),
                      from_date: e.start._date,
                      to_date: e.start._date,
                    },
                    () => {
                      console.log(this.state.check_morning);
                    }
                  );
                } else {
                  notify.show(
                    "Please set availability for today or future days"
                  );
                  return false;
                }
              }
            }}
            schedules={schedules}
            onLoad={this.handleRenderDate}
            onBeforeUpdateSchedule={(e) => {
              var schedule = e.schedule;
              var changes = e.changes;
              this.updateSchedule(schedule.id, schedule.calendarId, changes);
            }}
            template={{
              monthMoreClose: () => {
                return '<span class="tui-full-calendar-icon tui-full-calendar-ic-close"></span>';
              },

              schedule: (schedule) => {
                return this.getGridCategoryTemplate(schedule.category);
              },

              allday: (schedule) => {
                return `<div class=${schedule.calendarId == 1 ? "calendar-booking" : "calendar-interview"}>
              <span class="calendar-booking-desktop">${schedule.title}</span>

              <span class="calendar-booking-mobile">JOB</span>
							</div>`;
              },

              time: (schedule) => {
                // console.log(schedule)
                if (schedule.title === 'Not Available') {
                  return `<div class="availability-entry">
							      <img src="${not_available_icon}" class="not-available-icon"/>
							      <span class="availability-span">${schedule.title}</span>
							      </div>`;
                } else {
                  return `<div class="availability-entry">
							      <img src="${available_icon}" class="availability-icon"/>
							      <span class="availability-span">${schedule.title}</span>
							      </div>`;
                }
              },

              popupDetailDate: (isAllDay, start, end) => {
                return moment(start.toUTCString()).format("DD MMM YYYY");
              },

              popupDetailBody: (schedule) => {
                let { arrival_time, start_time, end_time, isAdmin } =
                  JSON.parse(schedule.body);
                if (start_time && !end_time) {
                  return `<p>${new Date(start_time).toLocaleString()}</p>
                <a href="/${"JobListing"}/${schedule.id}" class="job-list-link">View Job Description</a>`;
                } else {
                  let link = isAdmin ? "TeacherJoblistAdmin" : "TeacherJobList";
                  return `<p>Arrive at ${parseTime(arrival_time)} for ${parseTime(
                    start_time
                  )} Start</p>
                <p>End at ${parseTime(end_time)}</p>
                <a href="/${link}#${schedule.id.split("_")[0]}" class="job-list-link">View Job Details</a>
                <div class=${schedule.id.split("_")[1] && !isAdmin ? "" : "d-none"}>
                  <a href="/${link}#${schedule.id}" class="cancel-single-day-link">Request Day Off</a>
                </div>
                `;
                }
              },
            }}
          />
        </div>
      </div>
    );
  }
}

// export default toastcal;

const mapStateToProps = () => {}

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) => dispatch(updateToRoot(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(toastcal)
